import { ReportListItemData } from './report-base';

export class PayoutObject extends ReportListItemData {
  id: string;
  amount: number;
  arrival_date: Date;
  automatic: string;
  balance_transaction: string;
  created: Date;
  currency: string;
  description: string;
  destination: string;
  failure_balance_transaction: string;
  failure_code: string;
  failure_message: string;
  livemode: string;
  method: string;
  source_type: string;
  statement_descriptor: string;
  status: string;
  type: string;
}

export class PayoutReport {
  totalDepositedYesterday: number;
  totalExpected: number;
  list: PayoutObject[];

  constructor(data: any = {}) {
    this.totalDepositedYesterday = +data.totalDepositedYesterday;
    this.totalExpected = +data.totalExpected;
    this.list = data.payoutReportDataList ? data.payoutReportDataList.map(l => new PayoutObject(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/payout-report.ts